import React from "react";
import { isObject } from "@common/helpers/typeGuards";
import { format } from "date-fns";
import {
    RuleConditionDate,
    TransactionRuleCondition,
} from "@common/types/transactionRule";
import { Tag } from "@design-system/Tag/Tag";
import { RuleTagRow } from "../RuleTagRow";
import { RULE_TAG_PROPS } from "../ruleTagUtils";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleDateCondition: React.FC<Props> = ({ condition }) => {
    if (!isObject(condition.value)) {
        return null;
    }

    const value = condition.value as RuleConditionDate;

    if (value.after && value.before) {
        return (
            <RuleTagRow label="Date" type="condition">
                <Tag {...RULE_TAG_PROPS}>
                    Between {format(new Date(value.after), "MM/dd/yyyy")} and{" "}
                    {format(new Date(value.before), "MM/dd/yyyy")}
                </Tag>
            </RuleTagRow>
        );
    }

    if (value.after) {
        return (
            <RuleTagRow label="Date" type="condition">
                <Tag {...RULE_TAG_PROPS}>After</Tag>
                <Tag {...RULE_TAG_PROPS}>
                    {format(new Date(value.after), "MM/dd/yyyy")}
                </Tag>
            </RuleTagRow>
        );
    }

    if (value.before) {
        return (
            <RuleTagRow label="Date" type="condition">
                <Tag {...RULE_TAG_PROPS}>Before</Tag>
                <Tag {...RULE_TAG_PROPS}>
                    {format(new Date(value.before), "MM/dd/yyyy")}
                </Tag>
            </RuleTagRow>
        );
    }

    return null;
};
